
import React, { useContext, useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import ToggleForm from './ToggleForm';
import { AgendaContext } from '../context/AgendaContext';
import DocActionMenu from './DocActionMenu';
import UpcomingForm from './forms/UpcomingForm'
import { MeetingsWrapper } from '../styles/TableStyle';
import { useTranslation } from 'react-i18next';

const UpComingIntlMeetings = () => {
    const { t } = useTranslation(); 
    const { upComingIntlMeetings, setUpIntlComingMeetings } = useContext(AgendaContext);
    const [editItem, setEditItem] = useState({
        id: null,
        end_date: '',
        name: '',
        start_date: '',
        presence_type: '',
        registration_deadline: '',
        registration_url: '',
        location: '',
        registration_open: null
    })
    const [newItem, setNewItem] = useState({
        id: null,
        end_date: '',
        name: '',
        start_date: '',
        presence_type: '',
        registration_deadline: '',
        registration_url: '',
        location: '',
        registration_open: null
    })

    useEffect(() => {
        // Get items from local storage
        const storedItems = JSON.parse(localStorage.getItem('upcoming_intl_meetings')) || []
        if (storedItems.length > 0) {
            // Map through the current docs and replace with the stored version available
            setUpIntlComingMeetings((prevItems) => {
                const mergeItems = prevItems.map((doc) => {
                    const localStorageItems = storedItems.find((item) => item.id === doc.id)
                    // If an updated version exists and its different, return it to overwrite the original
                    if (localStorageItems && JSON.stringify(localStorageItems) !== JSON.stringify(doc)) {
                        return localStorageItems
                    }
                    return doc
                })
                // Get newly added items from local storage 
                const newItems = storedItems.filter((stored) => !prevItems.some((doc) => doc.id === stored.id))
                // Return the combined list: merged docs and new items from local storage
                return [...mergeItems, ...newItems]
            })
        }
    }, [setUpIntlComingMeetings]);

    const handleEditCancel = () => {
        setEditItem(prev => ({
            ...prev, 
            id: null
        })); 
    }; 

    const submitEditTask = (event) => {
        event.preventDefault();
        const { end_date, name, start_date, presence_type, registration_deadline, registration_url, location, registration_open } = editItem;
        setUpIntlComingMeetings((prevItems) => {
            const items = prevItems.map((item) => {
                if (item.id === editItem.id) {
                    const updatedItem = {
                        ...item,
                        end_date,
                        name,
                        start_date,
                        presence_type,
                        registration_deadline,
                        registration_url,
                        location,
                        registration_open
                    }
                    // Current list in local storage 
                    const getItem = JSON.parse(localStorage.getItem('upcoming_intl_meetings')) || [];
                    // Check if this task was already edited
                    const existingIndex = getItem.findIndex(i => i.id === updatedItem.id);
                    if (existingIndex !== -1) {
                        // Replace the item if it exist
                        getItem[existingIndex] = updatedItem;
                    } else {
                        // Otherwise save it to the list 
                        getItem.push(updatedItem)
                    }
                    localStorage.setItem('upcoming_intl_meetings', JSON.stringify(getItem))
                    return updatedItem
                }
                return item
            })
            return items
        })
        setEditItem({
            id: null,
            end_date: '',
            name: '',
            start_date: '',
            presence_type: '',
            registration_deadline: '',
            registration_url: '',
            location: '',
            registration_open: null
        })
    }
    const submitNewTask = (event) => {
        event.preventDefault();
        const { end_date, name, start_date, presence_type, registration_deadline, registration_url, location, registration_open } = newItem;
        const newDoc = {
            id: uuidv4(),
            end_date,
            name,
            start_date,
            presence_type,
            registration_deadline,
            registration_url,
            location,
            registration_open
        }
        setUpIntlComingMeetings((prevItems) => {
            const addNewDoc = [...prevItems, newDoc];
            const storedItems = JSON.parse(localStorage.getItem('upcoming_intl_meetings')) || [];
            const updatedStoredDocs = [...storedItems, newDoc]
            localStorage.setItem('upcoming_intl_meetings', JSON.stringify(updatedStoredDocs))
            return addNewDoc
        });
        setNewItem({
            id: null,
            end_date: '',
            name: '',
            start_date: '',
            presence_type: '',
            registration_deadline: '',
            registration_url: '',
            location: '',
            registration_open: null
        })
    }
    const handleNewTaskChange = (event) => {
        const { name, value, type, checked } = event.target
        setNewItem({
            ...newItem,
            [name]: type === 'checkbox' ? checked : value
        })
    }
    const handleEditTaskChange = (event) => {
        const { name, value, type, checked } = event.target
        setEditItem({
            ...editItem,
            [name]: type === 'checkbox' ? checked : value
        })
    }
    const handleEditTaskClick = (item) => {
        setEditItem({
            id: item.id,
            end_date: item.end_date,
            name: item.name,
            start_date: item.start_date,
            presence_type: item.presence_type,
            registration_deadline: item.registration_deadline,
            registration_url: item.registration_url,
            location: item.location,
            registration_open: item.registration_open
        })
    }

    const handleDeleteTask = (id) => {
        const deleteItem = upComingIntlMeetings.filter((item) => item.id !== id);
        setUpIntlComingMeetings(deleteItem)
        localStorage.setItem('upcoming_intl_meetings', JSON.stringify(deleteItem))
    }

    const showRegistrationLink = (item) => {
        const now = new Date();

        if (!item.registration_open) {
            return <p style={{ padding: '0.5rem 0 0 0' }}>{`${t('upComingMeeting.formLabels.registrationNotOpen')}.`}</p>;
        }

        const registrationOpen = new Date(item.registration_open)
        // const registrationDeadline = new Date(item.registration_deadline)
        const formatted = (d) => new Date(d).toLocaleDateString('sv-SE')

        if (registrationOpen >= now) {
            // Registration not open yet
            return <span>{`${t('upComingMeeting.formLabels.registrationOpen')} ${formatted(registrationOpen)}.`}</span>
        } else if (registrationOpen <= now) {
            return (
                <span>
                    {`${t('upComingMeeting.formLabels.registrationCloses')} ${formatted(item.registration_deadline)}, `}
                    <a href={item.registration_url}>
                        {t('upComingMeeting.formLabels.registrationLink.anchor')}
                    </a>
                    {`.`}
                </span>
            )
        }
    };

    const renderupComingIntlMeetings = () => {
        return upComingIntlMeetings.map((item, index) => {
            return (
                <MeetingsWrapper key={index}>
                    {editItem.id === item.id ? (
                        <UpcomingForm
                            theme='lightBlue'
                            submitTask={submitEditTask}
                            handleTaskChange={handleEditTaskChange}
                            handleEditCancel={handleEditCancel}
                            item={editItem}
                            message={`${t('common.edit')} ${t('upComingMeeting.internationalMeeting')} #${index + 1}`}
                            type='international'
                            isEditing={editItem.id === item.id}
                        />
                    ) : (
                        <>
                            <h6 className='cell cell-header cell-left'>{item.name}</h6>
                            <h6 className='cell cell-header'>
                                {`${new Date(item.start_date).toLocaleDateString()}\u0020\u2192\u0020${new Date(item.end_date).toLocaleDateString()}\u0020`}
                                <span>{item.presence_type === 'FACE_TO_FACE' ? 'F2F' : item.presence_type}</span>
                            </h6>
                            <div className='cell cell-last-item'>
                                <DocActionMenu
                                    item={item}
                                    handleDeleteText={handleDeleteTask}
                                    handleEditTextClick={handleEditTaskClick}
                                />
                            </div>
                            <span className='cell cell-bottom cell-left'>{item.location}</span>
                            <div className='cell cell-bottom'>
                                {showRegistrationLink(item)}
                            </div>
                            <div className='cell cell-last-item'></div>
                        </>
                    )}
                </MeetingsWrapper>
            )
        })
    }
    return (
        <div>
            {upComingIntlMeetings && upComingIntlMeetings.length > 0 ? (
                <div>
                    {renderupComingIntlMeetings()}
                </div>
            ) : (
                <span>{t('common.noContent')}</span>
            )}
            <ToggleForm>
                <UpcomingForm
                    theme='darkBlue'
                    submitTask={submitNewTask}
                    handleTaskChange={handleNewTaskChange}
                    item={newItem}
                    message={`${t('common.addBtnLabel')} ${t('upComingMeeting.internationalMeeting')}`}
                    type='international'
                />
            </ToggleForm>
        </div>
    )
}
export default UpComingIntlMeetings
